import { useEffect, useState } from "react";
import { dashboardApi } from "@/api/trackerApi";

interface DashboardStats {
  totalHours: number;
  billableHours: number;
  billableRatio: number;
  activeProjects: number;
  totalEntries: number;
}

interface DailyHours {
  date: string;
  hours: number;
}

export function useDashboard() {
  const [stats, setStats] = useState<DashboardStats | null>(null);
  const [dailyHours, setDailyHours] = useState<DailyHours[]>([]);
  const [recent, setRecent] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      dashboardApi.getStats(),
      dashboardApi.getDailyHours(),
      dashboardApi.getRecent(),
    ])
      .then(([s, d, r]) => {
        setStats(s);
        setDailyHours(d);
        setRecent(r);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  const maxDailyHours = Math.max(...dailyHours.map((d) => d.hours), 1);

  return { stats, dailyHours, recent, loading, maxDailyHours };
}
